var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.container && _vm.container.type === 'weather')?_c('WeatherCustomPageContent'):(!(_vm.container && _vm.container.html))?_c('CustomPageContent',{attrs:{"setup":_vm.container}}):_c('CustomPageAppLegacy',{attrs:{"container":_vm.container}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }